import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import AddContractToClosedData from "./components/AddContractToClosedData";
import { ROUTES } from "../../routes/routeKeys";

const initialData = {
  property_id: "",
  property_name: "",
  executed_loi: null,
  executed_loi_date:null,
  purchase_agreement_draft_distributed: null,
  executed_purchase_agreeement: null,
  transaction_timeline_distributed: null,
  earnest_deposite_confirmed: null,
  due_diligence_delivery_receipt_confirmed: null,
  title: null,
  address_title_issues: null,
  cordinate_inspection: null,
  survey_received: null,
  environmental_report_received: null,
  appraisal_received: null,
  negotiate_repairs: null,
  due_diligence_expiration_date: null,
  estoppel_snda_ordered: null,
  financing_approval: null,
  building_insurance_obtained: null,
  estoppel_snda_received: null,
  scheduled_closing: null,
  comission_invoice_wiring_instruction: null,
  review_settlement_statement: null,
  closed_date: null,

  // Add all _days fields here with default empty string
  earnest_deposite_confirmed_days: "",
  due_diligence_delivery_receipt_confirmed_days: "",
  title_days: "",
  address_title_issues_days: "",
  due_diligence_expiration_date_days: "",
  financing_approval_days: "",
  scheduled_closing_days: "",
};

const AddContractToClosed = () => {
  const [config] = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);

  const handleClose = () => {
    setFormData(initialData);
    setError({});
    setDisable(false);
    navigate(ROUTES.CONTACT_CLOSE);
  };

  // Validation: If date is filled → days must also be filled
  const validateDependentDates = () => {
    const newErrors = {};
    let hasError = false;

    const checks = [
      { date: "earnest_deposite_confirmed", days: "earnest_deposite_confirmed_days", label: "Earnest Deposit Confirmed" },
      { date: "due_diligence_delivery_receipt_confirmed", days: "due_diligence_delivery_receipt_confirmed_days", label: "Due Diligence Delivery Confirmed" },
      { date: "title", days: "title_days", label: "Title" },
      { date: "address_title_issues", days: "address_title_issues_days", label: "Address Title Issues" },
      { date: "due_diligence_expiration_date", days: "due_diligence_expiration_date_days", label: "Due Diligence Expiration Date" },
      { date: "financing_approval", days: "financing_approval_days", label: "Financing Approval" },
      { date: "scheduled_closing", days: "scheduled_closing_days", label: "Scheduled Closing" },
    ];

    checks.forEach(({ date, days, label }) => {
      if (formData[date] && !formData[days]) {
        newErrors[days] = `Please enter ${label} days`;
        hasError = true;
      }
    });

    if (hasError) {
      setError((prev) => ({ ...prev, ...newErrors }));
      NotificationManager.error("Please fill the 'Days' field for every date you entered.");
      return false;
    }
    return true;
  };

  // Helper to format Date to MM/DD/YYYY string for API
  const formatDateForAPI = (date) => {
    if (!date) return "";
    if (typeof date === "string") return date;
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
     setDisable(true);

    // Format dates for API
    const dataToSend = { ...formData };
    const dateFields = [
      "executed_loi", "executed_loi_date","purchase_agreement_draft_distributed", "executed_purchase_agreeement",
      "transaction_timeline_distributed", "earnest_deposite_confirmed", "due_diligence_delivery_receipt_confirmed",
      "title", "address_title_issues", "cordinate_inspection", "survey_received",
      "environmental_report_received", "appraisal_received", "negotiate_repairs",
      "due_diligence_expiration_date", "estoppel_snda_ordered", "financing_approval",
      "building_insurance_obtained", "estoppel_snda_received", "scheduled_closing",
      "comission_invoice_wiring_instruction", "review_settlement_statement", "closed_date"
    ];
    dateFields.forEach((field) => {
      if (dataToSend[field]) {
        dataToSend[field] = formatDateForAPI(dataToSend[field]);
      }
    });

    axios
      .post(`${BASE_URL}/contract-to-close`, dataToSend, config)
      .then((res) => {
        NotificationManager.success("Contract to Close added successfully!");
        handleClose();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response?.data?.errors || {});
        if (err.response?.data?.message) {
          NotificationManager.error(err.response.data.message);
        }
      });
  };

  return (
    <BaseLayout>
      <div className="contact-header">
        <p className="head-1 dark-H md:px-0 px-3">Add Contract To Close</p>
      </div>

      <AddContractToClosedData
        formData={formData}
        error={error}
        onSetFormData={setFormData}
        onSetError={setError}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        disable={disable}
      />
    </BaseLayout>
  );
};

export default AddContractToClosed;